/*
 * @Descripttion: 供应商订单明细reducer
 * @Author: 曹博
 * @Date: 2023-10-16 10:57:32
 * @LastEditors: 曹博
 * @LastEditTime: 2023-10-16 11:37:27
 */

import { LogisticsInformation } from '../../api/orderManage'
import { WaterMarkOption } from '../../components/previewModal'
import { ActionType, CustomAction } from '../../global'
import { orderdetailTabKey } from './hooks'

export type RadioDict = {
  [x in orderdetailTabKey]: {
    key: string
    keyName: string
    value: string
    // numMap: string
  }
}

export type ProgressTimeKey =
  // 订单确认时间
  | 'confirmTime'
  // 首次发货时间'
  | 'firstShipTime'
  // 发货完成时间
  | 'completeShipTime'
  // 收货入库完成时间
  | 'completeStockTime'
  // 订单完成时间
  | 'completeOrderTime'

export interface ProgressTime {
  title: string
  time: number | null
  timeKey: ProgressTimeKey
  description: string
}

interface State {
  currentRadioDict: RadioDict // 当前tab列表的值
  checkedRadioKey: orderdetailTabKey // 当前选中tab的key值
  isTableLoading?: boolean
  detailInfo: any
  selectedRows: any[]
  productList: any[]
  progressValue: string
  loading: boolean
  deliveryList: any[]
  returnDetailList: any[]
  cancelDetailList: any[]
  submitBtnLoading: boolean
  expressSelectList: any[]
  isChangeDeliveryInfoModalVisible: boolean
  expressSearchValue: string
  expressId: string
  progressTime: ProgressTime[]
  logisticsInfoList: LogisticsInformation[][]
  isPreviewModalVisible: boolean
  previewFileUrl: string
  waterMarkOption?: WaterMarkOption
  rejectModalOpen: boolean // 驳回弹框
  rejectReason: string // 驳回理由
  rejectLoading: boolean // 驳回确认按钮加载中
  showRejectTip: boolean // 驳回提示
  downLoadModal: boolean
  downLoadModalLoading: boolean
  downLoadSelectedRowKeys: string[]
  customerOrderCodeList: string[]
}

const initialRadioDict: RadioDict = {
  商品明细: {
    key: 'productDetail',
    value: '商品明细',
    keyName: '商品明细',
  },
  发货明细: {
    key: 'deliveryDetail',
    value: '发货明细',
    keyName: '发货明细',
  },
  退货明细: {
    key: 'returnDetail',
    value: '退货明细',
    keyName: '退货明细',
  },
  取消明细: {
    key: 'cancelDetail',
    value: '取消明细',
    keyName: '取消明细',
  },
}

// 初始化订单进度数据
const initialProgressTime: ProgressTime[] = [
  {
    title: '待确认',
    timeKey: 'confirmTime',
    time: null,
    description: '订单生成，供应商确认订单',
  },
  {
    title: '等待发货',
    timeKey: 'firstShipTime',
    time: null,
    description: '供应商新增发货单',
  },
  {
    title: '发货中',
    timeKey: 'completeShipTime',
    time: null,
    description: '将所有待发数量发货',
  },
  {
    title: '待收货入库',
    timeKey: 'completeStockTime',
    time: null,
    description: '采购入库已签收的物料',
  },
  {
    title: '订单完成',
    timeKey: 'completeOrderTime',
    time: null,
    description: '订单完成，可对账',
  },
]

export const initialState: State = {
  currentRadioDict: initialRadioDict,
  checkedRadioKey: '商品明细',
  isTableLoading: false,
  detailInfo: undefined,
  selectedRows: [],
  productList: [],
  progressValue: '',
  loading: false,
  deliveryList: [],
  returnDetailList: [],
  cancelDetailList: [],
  submitBtnLoading: false,
  expressSelectList: [],
  isChangeDeliveryInfoModalVisible: false,
  expressSearchValue: '',
  expressId: '',
  progressTime: initialProgressTime,
  logisticsInfoList: [],
  isPreviewModalVisible: false,
  previewFileUrl: '',
  rejectModalOpen: false,
  rejectReason: '',
  rejectLoading: false,
  showRejectTip: false,
  downLoadModal: false,
  downLoadModalLoading: false,
  downLoadSelectedRowKeys: [],
  customerOrderCodeList: [],
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setCheckedRadioKeyAction':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setCurrentRadioDictAction':
      newstate.currentRadioDict = action.payload
      return newstate
    case 'setIsTableLoadingAction':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setDetailInfoAction':
      newstate.detailInfo = action.payload
      return newstate
    case 'setSelectedRowsAction':
      newstate.selectedRows = action.payload
      return newstate
    case 'setProductListAction':
      newstate.productList = action.payload
      return newstate
    case 'setProgressValueAction':
      newstate.progressValue = action.payload
      return newstate
    case 'setLoadingAction':
      newstate.loading = action.payload
      return newstate
    case 'setDeliveryListAction':
      newstate.deliveryList = action.payload
      return newstate
    case 'setReturnDetailListAction':
      newstate.returnDetailList = action.payload
      return newstate
    case 'setCancelDetailListAction':
      newstate.cancelDetailList = action.payload
      return newstate
    case 'setSubmitBtnLoadingAction':
      newstate.submitBtnLoading = action.payload
      return newstate
    case 'setExpressSelectListAction':
      newstate.expressSelectList = action.payload
      return newstate
    case 'setIsChangeDeliveryInfoModalVisibleAction':
      newstate.isChangeDeliveryInfoModalVisible = action.payload
      return newstate
    case 'setExpressSearchValueAction':
      newstate.expressSearchValue = action.payload
      return newstate
    case 'setExpressIdAction':
      newstate.expressId = action.payload
      return newstate
    case 'setProgressTimeAction':
      newstate.progressTime = action.payload
      return newstate
    case 'setLogisticsInfoListAction':
      newstate.logisticsInfoList = action.payload
      return newstate
    case 'setIsPreviewModalVisibleAction':
      newstate.isPreviewModalVisible = action.payload
      return newstate
    case 'setPreviewFileUrlAction':
      newstate.previewFileUrl = action.payload
      return newstate
    case 'setWaterMarkOptionAction':
      newstate.waterMarkOption = action.payload
      return newstate
    case 'setRejectModalOpenAction':
      newstate.rejectModalOpen = action.payload
      return newstate
    case 'setRejectLoadingAction':
      newstate.rejectLoading = action.payload
      return newstate
    case 'setRejectReasonAction':
      newstate.rejectReason = action.payload
      return newstate
    case 'setShowRejectTipAction':
      newstate.showRejectTip = action.payload
      return newstate
    case 'setDownLoadModalAction':
      newstate.downLoadModal = action.payload
      return newstate
    case 'setDownLoadModalLoadingAction':
      newstate.downLoadModalLoading = action.payload
      return newstate
    case 'setDownLoadSelectedRowKeysAction':
      newstate.downLoadSelectedRowKeys = action.payload
      return newstate
    case 'setCustomerOrderCodeListAction':
      newstate.customerOrderCodeList = action.payload
      return newstate

    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置当前tab选项列表
 * @param key
 * @returns
 */
export const setCurrentRadioDictAction = (val: any): CustomAction<Action> => ({
  type: 'setCurrentRadioDictAction',
  payload: val,
})

/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
export const setCheckedRadioKeyAction = (
  val: React.Key,
): CustomAction<Action> => ({
  type: 'setCheckedRadioKeyAction',
  payload: val,
})

/**
 * 设置详情页信息对象
 */
export const setDetailInfoAction = (val: any): CustomAction<Action> => ({
  type: 'setDetailInfoAction',
  payload: val,
})

/**
 * 设置选中的行的信息列表
 * @param val
 * @returns
 */
export const setSelectedRowsAction = (val: any): CustomAction<Action> => ({
  type: 'setSelectedRowsAction',
  payload: val,
})

/**
 * 设置商品明细数组
 * @param val
 * @returns
 */
export const setProductListAction = (val: any): CustomAction<Action> => ({
  type: 'setProductListAction',
  payload: val,
})

/**
 * 设置商品明细进度筛选条件的值
 * @param val
 * @returns
 */
export const setProgressValueAction = (val: any): CustomAction<Action> => ({
  type: 'setProgressValueAction',
  payload: val,
})

/**
 * 设置加载状态
 * @param val
 * @returns
 */
export const setLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setLoadingAction',
  payload: val,
})

/**
 * 设置发货明细
 * @param val
 * @returns
 */
export const setDeliveryListAction = (val: any[]): CustomAction<Action> => ({
  type: 'setDeliveryListAction',
  payload: val,
})

/**
 * 设置退货明细
 * @param val
 * @returns
 */
export const setReturnDetailListAction = (
  val: any[],
): CustomAction<Action> => ({
  type: 'setReturnDetailListAction',
  payload: val,
})

/**
 * 设置取消明细
 * @param val
 * @returns
 */
export const setCancelDetailListAction = (
  val: any[],
): CustomAction<Action> => ({
  type: 'setCancelDetailListAction',
  payload: val,
})

/**
 * 设置提交按钮的loading状态
 * @param val
 * @returns
 */
export const setSubmitBtnLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setSubmitBtnLoadingAction',
  payload: val,
})

/**
 * 设置修改物流信息弹出框的显示状态
 * @param val
 * @returns
 */
export const setIsChangeDeliveryInfoModalVisibleAction = (
  val: any,
): CustomAction<Action> => ({
  type: 'setIsChangeDeliveryInfoModalVisibleAction',
  payload: val,
})

/**
 * 物流下拉框搜索值
 * @param val
 * @returns
 */
export const setExpressSearchValueAction = (
  val: string,
): CustomAction<Action> => ({
  type: 'setExpressSearchValueAction',
  payload: val,
})

/**
 * 物流下拉框搜索值
 * @param val
 * @returns
 */
export const setExpressIdAction = (val: string): CustomAction<Action> => ({
  type: 'setExpressIdAction',
  payload: val,
})

/**
 * 设置当前物流公司选择列表
 * @param val
 * @returns
 */
export const setExpressSelectListAction = (val: any): CustomAction<Action> => ({
  type: 'setExpressSelectListAction',
  payload: val,
})

/**
 * 设置当前物流公司选择列表
 * @param val
 * @returns
 */
export const setProgressTimeAction = (
  val: ProgressTime[],
): CustomAction<Action> => ({
  type: 'setProgressTimeAction',
  payload: val,
})

/**
 * @param val
 * @returns
 */
export const setIsTableLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsTableLoadingAction',
  payload: val,
})

// 物流信息
export const setLogisticsInfoListAction = (
  val: LogisticsInformation[][],
): CustomAction<Action> => ({
  type: 'setLogisticsInfoListAction',
  payload: val,
})

export const setIsPreviewModalVisibleAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsPreviewModalVisibleAction',
  payload: val,
})

export const setPreviewFileUrlAction = (val: string): CustomAction<Action> => ({
  type: 'setPreviewFileUrlAction',
  payload: val,
})

export const setWaterMarkOptionAction = (
  val?: WaterMarkOption,
): CustomAction<Action> => ({
  type: 'setWaterMarkOptionAction',
  payload: val,
})

// 拒绝接单弹框
export const setRejectModalOpenAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setRejectModalOpenAction',
  payload: val,
})

// 拒绝接单理由
export const setRejectReasonAction = (val: string): CustomAction<Action> => ({
  type: 'setRejectReasonAction',
  payload: val,
})

// 拒绝接单确认按钮loading
export const setRejectLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setRejectLoadingAction',
  payload: val,
})

// 拒绝接单理由为空提示
export const setShowTipAction = (val: boolean): CustomAction<Action> => ({
  type: 'setShowRejectTipAction',
  payload: val,
})

export const setDownLoadModalAciton = (val: boolean): CustomAction<Action> => ({
  type: 'setDownLoadModalAction',
  payload: val,
})

export const setDownLoadModalLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setDownLoadModalLoadingAction',
  payload: val,
})

export const setDownLoadSelectedRowKeysAction = (
  val: any,
): CustomAction<Action> => ({
  type: 'setDownLoadSelectedRowKeysAction',
  payload: val,
})

export const setCustomerOrderCodeListAction = (
  val: any,
): CustomAction<Action> => ({
  type: 'setCustomerOrderCodeListAction',
  payload: val,
})
/*
 * @Descripttion: 供应商订单明细reducer
 * @Author: 曹博
 * @Date: 2023-10-16 10:57:32
 * @LastEditors: 曹博
 * @LastEditTime: 2023-10-16 11:37:27
 */

import { LogisticsInformation } from '../../api/orderManage'
import { WaterMarkOption } from '../../components/previewModal'
import { ActionType, CustomAction } from '../../global'
import { orderdetailTabKey } from './hooks'

export type RadioDict = {
  [x in orderdetailTabKey]: {
    key: string
    keyName: string
    value: string
    // numMap: string
  }
}

export type ProgressTimeKey =
  // 订单确认时间
  | 'confirmTime'
  // 首次发货时间'
  | 'firstShipTime'
  // 发货完成时间
  | 'completeShipTime'
  // 收货入库完成时间
  | 'completeStockTime'
  // 订单完成时间
  | 'completeOrderTime'

export interface ProgressTime {
  title: string
  time: number | null
  timeKey: ProgressTimeKey
  description: string
}

interface State {
  currentRadioDict: RadioDict // 当前tab列表的值
  checkedRadioKey: orderdetailTabKey // 当前选中tab的key值
  isTableLoading?: boolean
  detailInfo: any
  selectedRows: any[]
  productList: any[]
  progressValue: string
  loading: boolean
  deliveryList: any[]
  returnDetailList: any[]
  cancelDetailList: any[]
  submitBtnLoading: boolean
  expressSelectList: any[]
  isChangeDeliveryInfoModalVisible: boolean
  expressSearchValue: string
  expressId: string
  progressTime: ProgressTime[]
  logisticsInfoList: LogisticsInformation[][]
  isPreviewModalVisible: boolean
  previewFileUrl: string
  waterMarkOption?: WaterMarkOption
  rejectModalOpen: boolean // 驳回弹框
  rejectReason: string // 驳回理由
  rejectLoading: boolean // 驳回确认按钮加载中
  showRejectTip: boolean // 驳回提示
  downLoadModal: boolean
  downLoadModalLoading: boolean
  downLoadSelectedRowKeys: string[]
  customerOrderCodeList: string[]
}

const initialRadioDict: RadioDict = {
  商品明细: {
    key: 'productDetail',
    value: '商品明细',
    keyName: '商品明细',
  },
  发货明细: {
    key: 'deliveryDetail',
    value: '发货明细',
    keyName: '发货明细',
  },
  退货明细: {
    key: 'returnDetail',
    value: '退货明细',
    keyName: '退货明细',
  },
  取消明细: {
    key: 'cancelDetail',
    value: '取消明细',
    keyName: '取消明细',
  },
}

// 初始化订单进度数据
const initialProgressTime: ProgressTime[] = [
  {
    title: '待确认',
    timeKey: 'confirmTime',
    time: null,
    description: '订单生成，供应商确认订单',
  },
  {
    title: '等待发货',
    timeKey: 'firstShipTime',
    time: null,
    description: '供应商新增发货单',
  },
  {
    title: '发货中',
    timeKey: 'completeShipTime',
    time: null,
    description: '将所有待发数量发货',
  },
  {
    title: '待收货入库',
    timeKey: 'completeStockTime',
    time: null,
    description: '采购入库已签收的物料',
  },
  {
    title: '订单完成',
    timeKey: 'completeOrderTime',
    time: null,
    description: '订单完成，可对账',
  },
]

export const initialState: State = {
  currentRadioDict: initialRadioDict,
  checkedRadioKey: '商品明细',
  isTableLoading: false,
  detailInfo: undefined,
  selectedRows: [],
  productList: [],
  progressValue: '',
  loading: false,
  deliveryList: [],
  returnDetailList: [],
  cancelDetailList: [],
  submitBtnLoading: false,
  expressSelectList: [],
  isChangeDeliveryInfoModalVisible: false,
  expressSearchValue: '',
  expressId: '',
  progressTime: initialProgressTime,
  logisticsInfoList: [],
  isPreviewModalVisible: false,
  previewFileUrl: '',
  rejectModalOpen: false,
  rejectReason: '',
  rejectLoading: false,
  showRejectTip: false,
  downLoadModal: false,
  downLoadModalLoading: false,
  downLoadSelectedRowKeys: [],
  customerOrderCodeList: [],
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setCheckedRadioKeyAction':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setCurrentRadioDictAction':
      newstate.currentRadioDict = action.payload
      return newstate
    case 'setIsTableLoadingAction':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setDetailInfoAction':
      newstate.detailInfo = action.payload
      return newstate
    case 'setSelectedRowsAction':
      newstate.selectedRows = action.payload
      return newstate
    case 'setProductListAction':
      newstate.productList = action.payload
      return newstate
    case 'setProgressValueAction':
      newstate.progressValue = action.payload
      return newstate
    case 'setLoadingAction':
      newstate.loading = action.payload
      return newstate
    case 'setDeliveryListAction':
      newstate.deliveryList = action.payload
      return newstate
    case 'setReturnDetailListAction':
      newstate.returnDetailList = action.payload
      return newstate
    case 'setCancelDetailListAction':
      newstate.cancelDetailList = action.payload
      return newstate
    case 'setSubmitBtnLoadingAction':
      newstate.submitBtnLoading = action.payload
      return newstate
    case 'setExpressSelectListAction':
      newstate.expressSelectList = action.payload
      return newstate
    case 'setIsChangeDeliveryInfoModalVisibleAction':
      newstate.isChangeDeliveryInfoModalVisible = action.payload
      return newstate
    case 'setExpressSearchValueAction':
      newstate.expressSearchValue = action.payload
      return newstate
    case 'setExpressIdAction':
      newstate.expressId = action.payload
      return newstate
    case 'setProgressTimeAction':
      newstate.progressTime = action.payload
      return newstate
    case 'setLogisticsInfoListAction':
      newstate.logisticsInfoList = action.payload
      return newstate
    case 'setIsPreviewModalVisibleAction':
      newstate.isPreviewModalVisible = action.payload
      return newstate
    case 'setPreviewFileUrlAction':
      newstate.previewFileUrl = action.payload
      return newstate
    case 'setWaterMarkOptionAction':
      newstate.waterMarkOption = action.payload
      return newstate
    case 'setRejectModalOpenAction':
      newstate.rejectModalOpen = action.payload
      return newstate
    case 'setRejectLoadingAction':
      newstate.rejectLoading = action.payload
      return newstate
    case 'setRejectReasonAction':
      newstate.rejectReason = action.payload
      return newstate
    case 'setShowRejectTipAction':
      newstate.showRejectTip = action.payload
      return newstate
    case 'setDownLoadModalAction':
      newstate.downLoadModal = action.payload
      return newstate
    case 'setDownLoadModalLoadingAction':
      newstate.downLoadModalLoading = action.payload
      return newstate
    case 'setDownLoadSelectedRowKeysAction':
      newstate.downLoadSelectedRowKeys = action.payload
      return newstate
    case 'setCustomerOrderCodeListAction':
      newstate.customerOrderCodeList = action.payload
      return newstate

    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置当前tab选项列表
 * @param key
 * @returns
 */
export const setCurrentRadioDictAction = (val: any): CustomAction<Action> => ({
  type: 'setCurrentRadioDictAction',
  payload: val,
})

/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
export const setCheckedRadioKeyAction = (
  val: React.Key,
): CustomAction<Action> => ({
  type: 'setCheckedRadioKeyAction',
  payload: val,
})

/**
 * 设置详情页信息对象
 */
export const setDetailInfoAction = (val: any): CustomAction<Action> => ({
  type: 'setDetailInfoAction',
  payload: val,
})

/**
 * 设置选中的行的信息列表
 * @param val
 * @returns
 */
export const setSelectedRowsAction = (val: any): CustomAction<Action> => ({
  type: 'setSelectedRowsAction',
  payload: val,
})

/**
 * 设置商品明细数组
 * @param val
 * @returns
 */
export const setProductListAction = (val: any): CustomAction<Action> => ({
  type: 'setProductListAction',
  payload: val,
})

/**
 * 设置商品明细进度筛选条件的值
 * @param val
 * @returns
 */
export const setProgressValueAction = (val: any): CustomAction<Action> => ({
  type: 'setProgressValueAction',
  payload: val,
})

/**
 * 设置加载状态
 * @param val
 * @returns
 */
export const setLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setLoadingAction',
  payload: val,
})

/**
 * 设置发货明细
 * @param val
 * @returns
 */
export const setDeliveryListAction = (val: any[]): CustomAction<Action> => ({
  type: 'setDeliveryListAction',
  payload: val,
})

/**
 * 设置退货明细
 * @param val
 * @returns
 */
export const setReturnDetailListAction = (
  val: any[],
): CustomAction<Action> => ({
  type: 'setReturnDetailListAction',
  payload: val,
})

/**
 * 设置取消明细
 * @param val
 * @returns
 */
export const setCancelDetailListAction = (
  val: any[],
): CustomAction<Action> => ({
  type: 'setCancelDetailListAction',
  payload: val,
})

/**
 * 设置提交按钮的loading状态
 * @param val
 * @returns
 */
export const setSubmitBtnLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setSubmitBtnLoadingAction',
  payload: val,
})

/**
 * 设置修改物流信息弹出框的显示状态
 * @param val
 * @returns
 */
export const setIsChangeDeliveryInfoModalVisibleAction = (
  val: any,
): CustomAction<Action> => ({
  type: 'setIsChangeDeliveryInfoModalVisibleAction',
  payload: val,
})

/**
 * 物流下拉框搜索值
 * @param val
 * @returns
 */
export const setExpressSearchValueAction = (
  val: string,
): CustomAction<Action> => ({
  type: 'setExpressSearchValueAction',
  payload: val,
})

/**
 * 物流下拉框搜索值
 * @param val
 * @returns
 */
export const setExpressIdAction = (val: string): CustomAction<Action> => ({
  type: 'setExpressIdAction',
  payload: val,
})

/**
 * 设置当前物流公司选择列表
 * @param val
 * @returns
 */
export const setExpressSelectListAction = (val: any): CustomAction<Action> => ({
  type: 'setExpressSelectListAction',
  payload: val,
})

/**
 * 设置当前物流公司选择列表
 * @param val
 * @returns
 */
export const setProgressTimeAction = (
  val: ProgressTime[],
): CustomAction<Action> => ({
  type: 'setProgressTimeAction',
  payload: val,
})

/**
 * @param val
 * @returns
 */
export const setIsTableLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsTableLoadingAction',
  payload: val,
})

// 物流信息
export const setLogisticsInfoListAction = (
  val: LogisticsInformation[][],
): CustomAction<Action> => ({
  type: 'setLogisticsInfoListAction',
  payload: val,
})

export const setIsPreviewModalVisibleAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsPreviewModalVisibleAction',
  payload: val,
})

export const setPreviewFileUrlAction = (val: string): CustomAction<Action> => ({
  type: 'setPreviewFileUrlAction',
  payload: val,
})

export const setWaterMarkOptionAction = (
  val?: WaterMarkOption,
): CustomAction<Action> => ({
  type: 'setWaterMarkOptionAction',
  payload: val,
})

// 拒绝接单弹框
export const setRejectModalOpenAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setRejectModalOpenAction',
  payload: val,
})

// 拒绝接单理由
export const setRejectReasonAction = (val: string): CustomAction<Action> => ({
  type: 'setRejectReasonAction',
  payload: val,
})

// 拒绝接单确认按钮loading
export const setRejectLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setRejectLoadingAction',
  payload: val,
})

// 拒绝接单理由为空提示
export const setShowTipAction = (val: boolean): CustomAction<Action> => ({
  type: 'setShowRejectTipAction',
  payload: val,
})

export const setDownLoadModalAciton = (val: boolean): CustomAction<Action> => ({
  type: 'setDownLoadModalAction',
  payload: val,
})

export const setDownLoadModalLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setDownLoadModalLoadingAction',
  payload: val,
})

export const setDownLoadSelectedRowKeysAction = (
  val: any,
): CustomAction<Action> => ({
  type: 'setDownLoadSelectedRowKeysAction',
  payload: val,
})

export const setCustomerOrderCodeListAction = (
  val: any,
): CustomAction<Action> => ({
  type: 'setCustomerOrderCodeListAction',
  payload: val,
})
